import requestGetCall from "../requestCall";
import { UN_SUBSCRIBE_VIA_EMAIL_URL } from "../apiConstants";

const UnSubscribeViaEmail = async (req) => {
  const baseData = {
    endPoint: UN_SUBSCRIBE_VIA_EMAIL_URL,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
    },
  };
  console.log("subs mail req: ", req);
  const res = await requestGetCall(baseData, req);
  console.log("subs mail res: ", res);
  return res;
};
export default UnSubscribeViaEmail;
